
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inzerat/[seo]/[id]",
      function () {
        return require("private-next-pages/inzerat/[seo]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inzerat/[seo]/[id]"])
      });
    }
  